import React from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Section, breakpoints } from '~styles/global'

const Testomonial = ({ stars, quote, author, location, className }) => {

  const { mobile } = breakpoints

  return (
    <Section className={className}>
        <div css={css`
            grid-column: span 12;
        `}>
            <div css={css`
                text-align: center;
                max-width: 820px;
                margin: 0 auto;
                ${mobile} {
                    max-width: 640px; 
                }
            `}>
                <p css={css`
                    font-size: 38px; 
                    letter-spacing: 0.29em;
                    ${mobile} {
                        font-size: 28px; 
                    }
                `}>
									{typeof stars === 'number' && stars > 0 && Array(stars).fill(`*`)}
                  {}
                </p>
                <p className="h1 serif" css={css`margin-bottom: 1.2em;`}>{quote}</p>
                <p>—{author}, {location}</p>
            </div>           
        </div>
    </Section>
  )
}

Testomonial.propTypes = {
    stars: PropTypes.number,
    quote: PropTypes.string,
    author: PropTypes.string,
    location: PropTypes.string,
    className: PropTypes.string,
}

Testomonial.defaultProps = {
    stars: 4,
    quote: 'This candle is phasellus rhoncus et tellus in euismod.',
    author: 'Janet',
    location: 'location',
}

export default Testomonial
